import { environment } from "../../../environments/environment";

export class SETTINGS {
    public static BASE_API = "localhost:3000";

    public static CHARGEBEE_SITE = environment.chargebeeSite;
  
    public static KEYS = {
      SECRET: "iIUsWtNZcf",
    };
  
    public static ACCESS_TOKEN = "%&^%^*@&*#";
    public static REFRESH_TOKEN = "&@&#&$(@&##";
    public static USER_PRIVILEGES = "%$^%((*";
    public static USER_PERMISSIONS = ")(&^&%^$*&*&$&*()*";
    public static USER_ROLE = ")(&^&%^$*&**&^%^&&^&&$&*()*";
    public static LOGGED_IN_USER = "#$%@^^%";
    public static PAYMENT = "F&1cD,hSa*KrvrtLd,*,R-;j,";

    // Password policy - matches backend configuration
    public static PASSWORD = {
        MIN_LENGTH: 8,
        REQUIRE_LOWERCASE: true,
        REQUIRE_UPPERCASE: true,
        REQUIRE_DIGIT: true,
        REQUIRE_SPECIAL_CHAR: true,
        VALIDATION_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/,
    }

    public static PASSWORD_ERROR_MESSAGES = {
        INVALID_FORMAT: "Password must be at least 8 characters long, contain at least one lowercase letter, one uppercase letter, one digit, and one special character (e.g., @, #, $, _, etc.).",
        REQUIRED: "Password is required",
        CURRENT_REQUIRED: "Current password is required",
        INCORRECT_CURRENT: "Current password is incorrect",
        SAME_AS_CURRENT: "New password cannot be the same as current password",
    }
 
    public static REGIONS = [
      {
        name: 'Afghanistan',
        code: 'AF',
        bounds: { north: 38.4911, south: 29.3772, west: 60.4784, east: 74.8795 },
        center: { lat: 33.9391, lng: 67.7100 },
        zoom: 6
      },
      {
        name: 'Albania',
        code: 'AL',
        bounds: { north: 42.6612, south: 39.6447, west: 19.2636, east: 21.0574 },
        center: { lat: 41.1533, lng: 20.1683 },
        zoom: 7
      },
      {
        name: 'Algeria',
        code: 'DZ',
        bounds: { north: 37.0938, south: 18.9681, west: -8.6846, east: 11.9795 },
        center: { lat: 28.0339, lng: 1.6596 },
        zoom: 5
      },
      {
        name: 'American Samoa',
        code: 'AS',
        bounds: { north: -11.0497, south: -14.3825, west: -171.0919, east: -168.1431 },
        center: { lat: -14.2710, lng: -170.1322 },
        zoom: 10
      },
      {
        name: 'Andorra',
        code: 'AD',
        bounds: { north: 42.6563, south: 42.4284, west: 1.4071, east: 1.7865 },
        center: { lat: 42.5462, lng: 1.6016 },
        zoom: 10
      },
      {
        name: 'Angola',
        code: 'AO',
        bounds: { north: -4.3902, south: -18.0389, west: 11.6792, east: 24.0821 },
        center: { lat: -11.2027, lng: 17.8739 },
        zoom: 5
      },
      {
        name: 'Anguilla',
        code: 'AI',
        bounds: { north: 18.2833, south: 18.1667, west: -63.1667, east: -62.9667 },
        center: { lat: 18.2206, lng: -63.0686 },
        zoom: 12
      },
      {
        name: 'Antarctica',
        code: 'AQ',
        bounds: { north: -60.0, south: -90.0, west: -180.0, east: 180.0 },
        center: { lat: -75.2509, lng: -0.0713 },
        zoom: 2
      },
      {
        name: 'Antigua and Barbuda',
        code: 'AG',
        bounds: { north: 17.7294, south: 16.9969, west: -61.9064, east: -61.6724 },
        center: { lat: 17.0608, lng: -61.7964 },
        zoom: 10
      },
      {
        name: 'Argentina',
        code: 'AR',
        bounds: { north: -21.7813, south: -55.0613, west: -73.5829, east: -53.5918 },
        center: { lat: -38.4161, lng: -63.6167 },
        zoom: 4
      },
      {
        name: 'Armenia',
        code: 'AM',
        bounds: { north: 41.3008, south: 38.8405, west: 43.4499, east: 46.7726 },
        center: { lat: 40.0691, lng: 45.0382 },
        zoom: 7
      },
      {
        name: 'Aruba',
        code: 'AW',
        bounds: { north: 12.6250, south: 12.4042, west: -70.0641, east: -69.8765 },
        center: { lat: 12.5211, lng: -69.9683 },
        zoom: 12
      },
      {
        name: 'Australia',
        code: 'AU',
        bounds: { north: -10.0628, south: -43.6346, west: 112.9211, east: 153.6387 },
        center: { lat: -25.2744, lng: 133.7751 },
        zoom: 4
      },
      {
        name: 'Austria',
        code: 'AT',
        bounds: { north: 49.1109, south: 46.2825, west: 9.3976, east: 17.2939 },
        center: { lat: 47.5162, lng: 14.5501 },
        zoom: 7
      },
      {
        name: 'Azerbaijan',
        code: 'AZ',
        bounds: { north: 41.9056, south: 38.3929, west: 44.7746, east: 50.3701 },
        center: { lat: 40.1431, lng: 47.5769 },
        zoom: 6
      },
      {
        name: 'Bahamas',
        code: 'BS',
        bounds: { north: 26.9192, south: 20.7120, west: -78.9953, east: -72.7477 },
        center: { lat: 25.0343, lng: -77.3963 },
        zoom: 7
      },
      {
        name: 'Bahrain',
        code: 'BH',
        bounds: { north: 26.2823, south: 25.7963, west: 50.4542, east: 50.6644 },
        center: { lat: 25.9304, lng: 50.6378 },
        zoom: 10
      },
      {
        name: 'Bangladesh',
        code: 'BD',
        bounds: { north: 26.6382, south: 20.7433, west: 88.0844, east: 92.6727 },
        center: { lat: 23.6850, lng: 90.3563 },
        zoom: 7
      },
      {
        name: 'Barbados',
        code: 'BB',
        bounds: { north: 13.3273, south: 13.0399, west: -59.6505, east: -59.4204 },
        center: { lat: 13.1939, lng: -59.5432 },
        zoom: 11
      },
      {
        name: 'Belarus',
        code: 'BY',
        bounds: { north: 56.1722, south: 51.2574, west: 23.1783, east: 32.7627 },
        center: { lat: 53.7098, lng: 27.9534 },
        zoom: 6
      },
      {
        name: 'Belgium',
        code: 'BE',
        bounds: { north: 51.5051, south: 49.4969, west: 2.5465, east: 6.4079 },
        center: { lat: 50.5039, lng: 4.4699 },
        zoom: 8
      },
      {
        name: 'Belize',
        code: 'BZ',
        bounds: { north: 18.4960, south: 15.8857, west: -89.2291, east: -87.7762 },
        center: { lat: 17.1899, lng: -88.4976 },
        zoom: 8
      },
      {
        name: 'Benin',
        code: 'BJ',
        bounds: { north: 12.4183, south: 6.2381, west: 0.7745, east: 3.8517 },
        center: { lat: 9.3077, lng: 2.3158 },
        zoom: 7
      },
      {
        name: 'Bermuda',
        code: 'BM',
        bounds: { north: 32.3939, south: 32.2466, west: -64.8969, east: -64.6120 },
        center: { lat: 32.3078, lng: -64.7505 },
        zoom: 12
      },
      {
        name: 'Bhutan',
        code: 'BT',
        bounds: { north: 28.3239, south: 26.7020, west: 88.7462, east: 92.1252 },
        center: { lat: 27.5142, lng: 90.4336 },
        zoom: 8
      },
      {
        name: 'Bolivia',
        code: 'BO',
        bounds: { north: -9.6809, south: -22.8961, west: -69.6402, east: -57.4531 },
        center: { lat: -16.2902, lng: -63.5887 },
        zoom: 5
      },
      {
        name: 'Bosnia and Herzegovina',
        code: 'BA',
        bounds: { north: 45.2398, south: 42.5553, west: 15.7189, east: 19.6222 },
        center: { lat: 43.9159, lng: 17.6791 },
        zoom: 7
      },
      {
        name: 'Botswana',
        code: 'BW',
        bounds: { north: -17.7806, south: -26.9065, west: 19.9989, east: 29.3753 },
        center: { lat: -22.3285, lng: 24.6849 },
        zoom: 6
      },
      {
        name: 'Brazil',
        code: 'BR',
        bounds: { north: 5.2718, south: -33.7509, west: -73.9855, east: -34.7299 },
        center: { lat: -14.2350, lng: -51.9253 },
        zoom: 4
      },
      {
        name: 'British Virgin Islands',
        code: 'VG',
        bounds: { north: 18.7550, south: 18.3833, west: -64.7747, east: -64.2647 },
        center: { lat: 18.4207, lng: -64.6390 },
        zoom: 11
      },
      {
        name: 'Brunei',
        code: 'BN',
        bounds: { north: 5.0471, south: 4.0025, west: 114.0758, east: 115.3635 },
        center: { lat: 4.5353, lng: 114.7277 },
        zoom: 9
      },
      {
        name: 'Bulgaria',
        code: 'BG',
        bounds: { north: 44.2167, south: 41.2354, west: 22.3571, east: 28.6122 },
        center: { lat: 42.7339, lng: 25.4858 },
        zoom: 7
      },
      {
        name: 'Burkina Faso',
        code: 'BF',
        bounds: { north: 15.0826, south: 9.4011, west: -5.5132, east: 2.4053 },
        center: { lat: 12.2383, lng: -1.5616 },
        zoom: 6
      },
      {
        name: 'Burundi',
        code: 'BI',
        bounds: { north: -2.3101, south: -4.4657, west: 28.9931, east: 30.8479 },
        center: { lat: -3.3731, lng: 29.9189 },
        zoom: 8
      },
      {
        name: 'Cambodia',
        code: 'KH',
        bounds: { north: 14.6864, south: 10.4865, west: 102.3480, east: 107.6277 },
        center: { lat: 12.5657, lng: 104.9910 },
        zoom: 7
      },
      {
        name: 'Cameroon',
        code: 'CM',
        bounds: { north: 13.0839, south: 1.6546, west: 8.4948, east: 16.1921 },
        center: { lat: 7.3697, lng: 12.3547 },
        zoom: 6
      },
      {
        name: 'Canada',
        code: 'CA',
        bounds: { north: 83.3362, south: 41.6766, west: -141.0028, east: -52.3234 },
        center: { lat: 56.1304, lng: -106.3468 },
        zoom: 4
      },
      {
        name: 'Cape Verde',
        code: 'CV',
        bounds: { north: 17.1971, south: 14.8082, west: -25.3582, east: -22.6672 },
        center: { lat: 16.0021, lng: -24.0132 },
        zoom: 9
      },
      {
        name: 'Cayman Islands',
        code: 'KY',
        bounds: { north: 19.7617, south: 19.2630, west: -81.4327, east: -79.7273 },
        center: { lat: 19.3133, lng: -81.2546 },
        zoom: 11
      },
      {
        name: 'Central African Republic',
        code: 'CF',
        bounds: { north: 11.0014, south: 2.2676, west: 14.4155, east: 27.4544 },
        center: { lat: 6.6111, lng: 20.9394 },
        zoom: 6
      },
      {
        name: 'Chad',
        code: 'TD',
        bounds: { north: 23.4507, south: 7.4411, west: 13.4734, east: 24.0021 },
        center: { lat: 15.4542, lng: 18.7322 },
        zoom: 5
      },
      {
        name: 'Chile',
        code: 'CL',
        bounds: { north: -17.5045, south: -56.7250, west: -109.4242, east: -66.4179 },
        center: { lat: -35.6751, lng: -71.5430 },
        zoom: 4
      },
      {
        name: 'China',
        code: 'CN',
        bounds: { north: 53.5609, south: 18.1597, west: 73.5577, east: 135.0000 },
        center: { lat: 35.8617, lng: 104.1954 },
        zoom: 4
      },
      {
        name: 'Christmas Island',
        code: 'CX',
        bounds: { north: -10.4124, south: -10.5708, west: 105.5334, east: 105.7129 },
        center: { lat: -10.4475, lng: 105.6904 },
        zoom: 12
      },
      {
        name: 'Cocos Islands',
        code: 'CC',
        bounds: { north: -11.8017, south: -12.2085, west: 96.8209, east: 96.9189 },
        center: { lat: -12.1642, lng: 96.8710 },
        zoom: 12
      },
      {
        name: 'Colombia',
        code: 'CO',
        bounds: { north: 15.5087, south: -4.2278, west: -81.7286, east: -66.8698 },
        center: { lat: 4.5709, lng: -74.2973 },
        zoom: 5
      },
      {
        name: 'Comoros',
        code: 'KM',
        bounds: { north: -11.3623, south: -12.3879, west: 43.2158, east: 44.5382 },
        center: { lat: -11.8750, lng: 43.8722 },
        zoom: 10
      },
      {
        name: 'Congo',
        code: 'CG',
        bounds: { north: 3.7032, south: -5.0371, west: 11.2057, east: 18.6499 },
        center: { lat: -0.2280, lng: 15.8277 },
        zoom: 6
      },
      {
        name: 'Cook Islands',
        code: 'CK',
        bounds: { north: -8.7167, south: -22.1581, west: -166.0628, east: -157.3128 },
        center: { lat: -21.2367, lng: -159.7777 },
        zoom: 8
      },
      {
        name: 'Costa Rica',
        code: 'CR',
        bounds: { north: 11.2168, south: 8.0370, west: -85.9506, east: -82.5461 },
        center: { lat: 9.7489, lng: -83.7534 },
        zoom: 8
      },
      {
        name: 'Croatia',
        code: 'HR',
        bounds: { north: 46.5935, south: 42.3901, west: 13.3792, east: 19.5176 },
        center: { lat: 45.1000, lng: 15.2000 },
        zoom: 7
      },
      {
        name: 'Cuba',
        code: 'CU',
        bounds: { north: 23.2775, south: 19.8285, west: -84.9749, east: -74.1780 },
        center: { lat: 21.5218, lng: -77.7812 },
        zoom: 6
      },
      {
        name: 'Cyprus',
        code: 'CY',
        bounds: { north: 35.7015, south: 34.5719, west: 32.2565, east: 34.5979 },
        center: { lat: 35.1264, lng: 33.4299 },
        zoom: 9
      },
      {
        name: 'Czech Republic',
        code: 'CZ',
        bounds: { north: 51.1455, south: 48.4627, west: 11.9571, east: 18.9916 },
        center: { lat: 49.8175, lng: 15.4730 },
        zoom: 7
      },
      {
        name: 'Denmark',
        code: 'DK',
        bounds: { north: 57.8382, south: 54.4696, west: 7.9138, east: 15.3206 },
        center: { lat: 56.2639, lng: 9.5018 },
        zoom: 7
      },
      {
        name: 'Djibouti',
        code: 'DJ',
        bounds: { north: 12.7923, south: 10.9268, west: 41.7739, east: 43.6579 },
        center: { lat: 11.8251, lng: 42.5903 },
        zoom: 8
      },
      {
        name: 'Dominica',
        code: 'DM',
        bounds: { north: 15.6318, south: 15.2019, west: -61.4841, east: -61.2441 },
        center: { lat: 15.4150, lng: -61.3710 },
        zoom: 11
      },
      {
        name: 'Dominican Republic',
        code: 'DO',
        bounds: { north: 19.9298, south: 17.5406, west: -72.0041, east: -68.3179 },
        center: { lat: 18.7357, lng: -70.1627 },
        zoom: 8
      },
      {
        name: 'East Timor',
        code: 'TL',
        bounds: { north: -8.1242, south: -9.4636, west: 124.0416, east: 127.3080 },
        center: { lat: -8.8742, lng: 125.7275 },
        zoom: 9
      },
      {
        name: 'Ecuador',
        code: 'EC',
        bounds: { north: 1.4558, south: -5.0159, west: -92.0035, east: -75.1925 },
        center: { lat: -1.8312, lng: -78.1834 },
        zoom: 6
      },
      {
        name: 'Egypt',
        code: 'EG',
        bounds: { north: 31.6680, south: 21.7254, west: 24.6499, east: 36.8662 },
        center: { lat: 26.0975, lng: 30.0444 },
        zoom: 5
      },
      {
        name: 'El Salvador',
        code: 'SV',
        bounds: { north: 14.4450, south: 13.1490, west: -90.0955, east: -87.7235 },
        center: { lat: 13.7942, lng: -88.8965 },
        zoom: 9
      },
      {
        name: 'Equatorial Guinea',
        code: 'GQ',
        bounds: { north: 3.7971, south: -1.4686, west: 5.6308, east: 11.3351 },
        center: { lat: 1.6508, lng: 10.2679 },
        zoom: 8
      },
      {
        name: 'Eritrea',
        code: 'ER',
        bounds: { north: 18.0030, south: 12.3548, west: 36.4338, east: 43.1342 },
        center: { lat: 15.1794, lng: 39.7823 },
        zoom: 7
      },
      {
        name: 'Estonia',
        code: 'EE',
        bounds: { north: 59.6763, south: 57.4745, west: 21.8373, east: 28.2100 },
        center: { lat: 58.5953, lng: 25.0136 },
        zoom: 7
      },
      {
        name: 'Ethiopia',
        code: 'ET',
        bounds: { north: 18.0030, south: 3.4022, west: 32.9975, east: 47.9792 },
        center: { lat: 9.1450, lng: 40.4897 },
        zoom: 6
      },
      {
        name: 'Falkland Islands',
        code: 'FK',
        bounds: { north: -51.2406, south: -52.3605, west: -61.3452, east: -57.7124 },
        center: { lat: -51.7963, lng: -59.5236 },
        zoom: 9
      },
      {
        name: 'Faroe Islands',
        code: 'FO',
        bounds: { north: 62.4007, south: 61.3948, west: -7.6882, east: -6.2568 },
        center: { lat: 61.8926, lng: -6.9118 },
        zoom: 9
      },
      {
        name: 'Fiji',
        code: 'FJ',
        bounds: { north: -16.0208, south: -20.6759, west: -180.0, east: 180.0 },
        center: { lat: -16.5788, lng: 179.4144 },
        zoom: 7
      },
      {
        name: 'Finland',
        code: 'FI',
        bounds: { north: 70.0923, south: 59.8084, west: 20.5569, east: 31.5867 },
        center: { lat: 61.9241, lng: 25.7482 },
        zoom: 5
      },
      {
        name: 'France',
        code: 'FR',
        bounds: { north: 51.0890, south: 41.3718, west: -5.1427, east: 9.5596 },
        center: { lat: 46.2276, lng: 2.2137 },
        zoom: 6
      },
      {
        name: 'French Guiana',
        code: 'GF',
        bounds: { north: 5.7765, south: 2.1128, west: -54.6024, east: -51.6357 },
        center: { lat: 3.9339, lng: -53.1258 },
        zoom: 7
      },
      {
        name: 'French Polynesia',
        code: 'PF',
        bounds: { north: -7.7806, south: -27.6533, west: -154.6823, east: -134.4728 },
        center: { lat: -17.6797, lng: -149.4068 },
        zoom: 6
      },
      {
        name: 'Gabon',
        code: 'GA',
        bounds: { north: 2.3181, south: -3.9782, west: 8.6954, east: 14.5025 },
        center: { lat: -0.8037, lng: 11.6094 },
        zoom: 6
      },
      {
        name: 'Gambia',
        code: 'GM',
        bounds: { north: 13.8263, south: 13.0642, west: -16.8415, east: -13.7975 },
        center: { lat: 13.4432, lng: -15.3101 },
        zoom: 8
      },
      {
        name: 'Georgia',
        code: 'GE',
        bounds: { north: 43.5865, south: 41.0534, west: 39.9550, east: 46.7259 },
        center: { lat: 42.3154, lng: 43.3569 },
        zoom: 7
      },
      {
        name: 'Germany',
        code: 'DE',
        bounds: { north: 55.1482, south: 47.1803, west: 5.7226, east: 15.1856 },
        center: { lat: 51.1657, lng: 10.4515 },
        zoom: 6
      },
      {
        name: 'Ghana',
        code: 'GH',
        bounds: { north: 11.1740, south: 4.7364, west: -3.2554, east: 1.2732 },
        center: { lat: 7.9465, lng: -1.0232 },
        zoom: 6
      },
      {
        name: 'Gibraltar',
        code: 'GI',
        bounds: { north: 36.1554, south: 36.1097, west: -5.3573, east: -5.3381 },
        center: { lat: 36.1408, lng: -5.3536 },
        zoom: 13
      },
      {
        name: 'Greece',
        code: 'GR',
        bounds: { north: 41.7488, south: 34.8020, west: 19.3736, east: 29.7295 },
        center: { lat: 39.0742, lng: 21.8243 },
        zoom: 6
      },
      {
        name: 'Greenland',
        code: 'GL',
        bounds: { north: 83.6274, south: 59.7774, west: -73.0472, east: -12.2085 },
        center: { lat: 71.7069, lng: -42.6043 },
        zoom: 3
      },
      {
        name: 'Grenada',
        code: 'GD',
        bounds: { north: 12.5200, south: 11.9840, west: -61.8079, east: -61.3840 },
        center: { lat: 12.2626, lng: -61.6019 },
        zoom: 11
      },
      {
        name: 'Guadeloupe',
        code: 'GP',
        bounds: { north: 16.5169, south: 15.8320, west: -61.8097, east: -61.0000 },
        center: { lat: 16.9950, lng: -62.0676 },
        zoom: 10
      },
      {
        name: 'Guam',
        code: 'GU',
        bounds: { north: 13.6543, south: 13.2341, west: 144.6180, east: 144.9567 },
        center: { lat: 13.4443, lng: 144.7937 },
        zoom: 11
      },
      {
        name: 'Guatemala',
        code: 'GT',
        bounds: { north: 17.8156, south: 13.7378, west: -92.2292, east: -88.2250 },
        center: { lat: 15.7835, lng: -90.2308 },
        zoom: 7
      },
      {
        name: 'Guernsey',
        code: 'GG',
        bounds: { north: 49.7378, south: 49.4075, west: -2.6752, east: -2.1580 },
        center: { lat: 49.4659, lng: -2.5853 },
        zoom: 11
      },
      {
        name: 'Guinea',
        code: 'GN',
        bounds: { north: 12.6866, south: 7.3091, west: -15.1303, east: -7.6411 },
        center: { lat: 9.6412, lng: -9.6966 },
        zoom: 6
      },
      {
        name: 'Guinea-Bissau',
        code: 'GW',
        bounds: { north: 12.6800, south: 10.7402, west: -16.7175, east: -13.6365 },
        center: { lat: 11.8037, lng: -15.1804 },
        zoom: 8
      },
      {
        name: 'Guyana',
        code: 'GY',
        bounds: { north: 8.5571, south: 1.1710, west: -61.4103, east: -56.4680 },
        center: { lat: 4.8604, lng: -58.9302 },
        zoom: 6
      },
      {
        name: 'Haiti',
        code: 'HT',
        bounds: { north: 20.0878, south: 18.0219, west: -74.4580, east: -71.6248 },
        center: { lat: 18.9712, lng: -72.2852 },
        zoom: 8
      },
      {
        name: 'Honduras',
        code: 'HN',
        bounds: { north: 16.0168, south: 12.9829, west: -89.3533, east: -83.1472 },
        center: { lat: 15.2000, lng: -86.2419 },
        zoom: 7
      },
      {
        name: 'Hong Kong',
        code: 'HK',
        bounds: { north: 22.5597, south: 22.1534, west: 113.8388, east: 114.4341 },
        center: { lat: 22.3193, lng: 114.1694 },
        zoom: 10
      },
      {
        name: 'Hungary',
        code: 'HU',
        bounds: { north: 48.6752, south: 45.6473, west: 15.9819, east: 23.0379 },
        center: { lat: 47.1625, lng: 19.5033 },
        zoom: 7
      },
      {
        name: 'Iceland',
        code: 'IS',
        bounds: { north: 66.5268, south: 63.4963, west: -24.3265, east: -13.6093 },
        center: { lat: 64.9631, lng: -19.0208 },
        zoom: 6
      },
      {
        name: 'India',
        code: 'IN',
        bounds: { north: 35.5985, south: 6.3728, west: 68.0807, east: 97.4984 },
        center: { lat: 20.5937, lng: 78.9629 },
        zoom: 5
      },
      {
        name: 'Indonesia',
        code: 'ID',
        bounds: { north: 6.0819, south: -11.0075, west: 95.0090, east: 141.0194 },
        center: { lat: -0.7893, lng: 113.9213 },
        zoom: 5
      },
      {
        name: 'Iran',
        code: 'IR',
        bounds: { north: 39.7816, south: 25.0640, west: 44.0319, east: 63.3166 },
        center: { lat: 32.4279, lng: 53.6880 },
        zoom: 5
      },
      {
        name: 'Iraq',
        code: 'IQ',
        bounds: { north: 37.3852, south: 29.0694, west: 38.7923, east: 48.5679 },
        center: { lat: 33.2232, lng: 43.6793 },
        zoom: 6
      },
      {
        name: 'Ireland',
        code: 'IE',
        bounds: { north: 55.3877, south: 51.4220, west: -10.4800, east: -6.0029 },
        center: { lat: 53.4129, lng: -8.2439 },
        zoom: 7
      },
      {
        name: 'Isle of Man',
        code: 'IM',
        bounds: { north: 54.4197, south: 54.0550, west: -4.7984, east: -4.3115 },
        center: { lat: 54.2361, lng: -4.5481 },
        zoom: 10
      },
      {
        name: 'Israel',
        code: 'IL',
        bounds: { north: 33.3356, south: 29.4960, west: 34.2674, east: 35.8364 },
        center: { lat: 31.0461, lng: 34.8516 },
        zoom: 8
      },
      {
        name: 'Italy',
        code: 'IT',
        bounds: { north: 47.1819, south: 35.4031, west: 6.5060, east: 18.9182 },
        center: { lat: 41.8719, lng: 12.5674 },
        zoom: 6
      },
      {
        name: 'Ivory Coast',
        code: 'CI',
        bounds: { north: 10.7400, south: 4.3570, west: -8.6021, east: -2.4941 },
        center: { lat: 7.5400, lng: -5.5471 },
        zoom: 6
      },
      {
        name: 'Jamaica',
        code: 'JM',
        bounds: { north: 18.5242, south: 17.7011, west: -78.3677, east: -76.1996 },
        center: { lat: 18.1096, lng: -77.2975 },
        zoom: 9
      },
      {
        name: 'Japan',
        code: 'JP',
        bounds: { north: 45.5572, south: 24.2129, west: 122.9336, east: 153.9866 },
        center: { lat: 36.2048, lng: 138.2529 },
        zoom: 5
      },
      {
        name: 'Jersey',
        code: 'JE',
        bounds: { north: 49.2650, south: 49.1700, west: -2.2610, east: -2.0220 },
        center: { lat: 49.2144, lng: -2.1312 },
        zoom: 12
      },
      {
        name: 'Jordan',
        code: 'JO',
        bounds: { north: 33.3756, south: 29.1974, west: 34.9226, east: 39.3012 },
        center: { lat: 30.5852, lng: 36.2384 },
        zoom: 7
      },
      {
        name: 'Kazakhstan',
        code: 'KZ',
        bounds: { north: 55.4421, south: 40.9306, west: 46.4932, east: 87.3599 },
        center: { lat: 48.0196, lng: 66.9237 },
        zoom: 4
      },
      {
        name: 'Kenya',
        code: 'KE',
        bounds: { north: 5.5069, south: -4.8995, west: 33.9098, east: 41.8999 },
        center: { lat: -0.0236, lng: 37.9062 },
        zoom: 6
      },
      {
        name: 'Kiribati',
        code: 'KI',
        bounds: { north: 4.7196, south: -4.7196, west: -174.5431, east: -150.2159 },
        center: { lat: -3.3704, lng: -168.7340 },
        zoom: 6
      },
      {
        name: 'Kosovo',
        code: 'XK',
        bounds: { north: 43.2682, south: 41.8565, west: 20.0707, east: 21.8032 },
        center: { lat: 42.6026, lng: 20.9029 },
        zoom: 8
      },
      {
        name: 'Kuwait',
        code: 'KW',
        bounds: { north: 30.0959, south: 28.5243, west: 46.5687, east: 48.4316 },
        center: { lat: 29.3117, lng: 47.4818 },
        zoom: 8
      },
      {
        name: 'Kyrgyzstan',
        code: 'KG',
        bounds: { north: 43.2982, south: 39.1727, west: 69.2766, east: 80.2832 },
        center: { lat: 41.2044, lng: 74.7661 },
        zoom: 6
      },
      {
        name: 'Laos',
        code: 'LA',
        bounds: { north: 22.5086, south: 13.9100, west: 100.0843, east: 107.6350 },
        center: { lat: 19.8563, lng: 102.4955 },
        zoom: 6
      },
      {
        name: 'Latvia',
        code: 'LV',
        bounds: { north: 58.0856, south: 55.6745, west: 20.9794, east: 28.2417 },
        center: { lat: 56.8796, lng: 24.6032 },
        zoom: 7
      },
      {
        name: 'Lebanon',
        code: 'LB',
        bounds: { north: 34.6914, south: 33.0471, west: 35.1042, east: 36.6111 },
        center: { lat: 33.8547, lng: 35.8623 },
        zoom: 8
      },
      {
        name: 'Lesotho',
        code: 'LS',
        bounds: { north: -28.5700, south: -30.6775, west: 27.0114, east: 29.4559 },
        center: { lat: -29.6100, lng: 28.2336 },
        zoom: 8
      },
      {
        name: 'Liberia',
        code: 'LR',
        bounds: { north: 8.5518, south: 4.3530, west: -11.4387, east: -7.3691 },
        center: { lat: 6.4281, lng: -9.4295 },
        zoom: 7
      },
      {
        name: 'Libya',
        code: 'LY',
        bounds: { north: 33.1689, south: 19.5080, west: 9.3194, east: 25.1506 },
        center: { lat: 26.3351, lng: 17.2283 },
        zoom: 5
      },
      {
        name: 'Liechtenstein',
        code: 'LI',
        bounds: { north: 47.2706, south: 47.0484, west: 9.4718, east: 9.6357 },
        center: { lat: 47.1660, lng: 9.5554 },
        zoom: 11
      },
      {
        name: 'Lithuania',
        code: 'LT',
        bounds: { north: 56.3725, south: 53.8967, west: 20.9341, east: 26.8355 },
        center: { lat: 55.1694, lng: 23.8813 },
        zoom: 7
      },
      {
        name: 'Luxembourg',
        code: 'LU',
        bounds: { north: 50.1828, south: 49.4426, west: 5.6744, east: 6.5309 },
        center: { lat: 49.8153, lng: 6.1296 },
        zoom: 9
      },
      {
        name: 'Macau',
        code: 'MO',
        bounds: { north: 22.2209, south: 22.1067, west: 113.5288, east: 113.5909 },
        center: { lat: 22.1987, lng: 113.5439 },
        zoom: 12
      },
      {
        name: 'Macedonia',
        code: 'MK',
        bounds: { north: 42.3735, south: 40.8427, west: 20.4529, east: 23.0342 },
        center: { lat: 41.6086, lng: 21.7453 },
        zoom: 8
      },
      {
        name: 'Madagascar',
        code: 'MG',
        bounds: { north: -11.9454, south: -25.6014, west: 43.2541, east: 50.4765 },
        center: { lat: -18.7669, lng: 46.8691 },
        zoom: 6
      },
      {
        name: 'Malawi',
        code: 'MW',
        bounds: { north: -9.3675, south: -17.1294, west: 32.6703, east: 35.9185 },
        center: { lat: -13.2543, lng: 34.3015 },
        zoom: 7
      },
      {
        name: 'Malaysia',
        code: 'MY',
        bounds: { north: 7.3634, south: 0.8550, west: 99.6437, east: 119.2675 },
        center: { lat: 4.2105, lng: 101.9758 },
        zoom: 6
      },
      {
        name: 'Maldives',
        code: 'MV',
        bounds: { north: 7.0919, south: -0.6927, west: 72.6932, east: 73.7377 },
        center: { lat: 3.2028, lng: 73.2207 },
        zoom: 8
      },
      {
        name: 'Mali',
        code: 'ML',
        bounds: { north: 25.0000, south: 10.1595, west: -12.2403, east: 4.2673 },
        center: { lat: 17.5707, lng: -3.9962 },
        zoom: 5
      },
      {
        name: 'Malta',
        code: 'MT',
        bounds: { north: 36.0821, south: 35.8048, west: 14.1834, east: 14.5765 },
        center: { lat: 35.9375, lng: 14.3754 },
        zoom: 11
      },
      {
        name: 'Marshall Islands',
        code: 'MH',
        bounds: { north: 14.7159, south: 4.5659, west: 160.7961, east: 172.0 },
        center: { lat: 7.1315, lng: 171.1845 },
        zoom: 8
      },
      {
        name: 'Martinique',
        code: 'MQ',
        bounds: { north: 14.8788, south: 14.4089, west: -61.2290, east: -60.8092 },
        center: { lat: 14.6415, lng: -61.0242 },
        zoom: 10
      },
      {
        name: 'Mauritania',
        code: 'MR',
        bounds: { north: 27.3147, south: 14.7159, west: -17.0634, east: -4.8273 },
        center: { lat: 21.0079, lng: -10.9408 },
        zoom: 5
      },
      {
        name: 'Mauritius',
        code: 'MU',
        bounds: { north: -10.3192, south: -20.5257, west: 56.5127, east: 63.5002 },
        center: { lat: -20.3484, lng: 57.5522 },
        zoom: 9
      },
      {
        name: 'Mayotte',
        code: 'YT',
        bounds: { north: -12.6436, south: -13.0214, west: 45.0189, east: 45.2999 },
        center: { lat: -12.8275, lng: 45.1662 },
        zoom: 11
      },
      {
        name: 'Mexico',
        code: 'MX',
        bounds: { north: 32.7167, south: 14.5328, west: -118.4539, east: -86.7100 },
        center: { lat: 23.6345, lng: -102.5528 },
        zoom: 5
      },
      {
        name: 'Micronesia',
        code: 'FM',
        bounds: { north: 10.0899, south: 1.0269, west: 137.3364, east: 163.0349 },
        center: { lat: 7.4256, lng: 150.5508 },
        zoom: 7
      },
      {
        name: 'Moldova',
        code: 'MD',
        bounds: { north: 48.4671, south: 45.4671, west: 26.6193, east: 30.1354 },
        center: { lat: 47.4116, lng: 28.3699 },
        zoom: 7
      },
      {
        name: 'Monaco',
        code: 'MC',
        bounds: { north: 43.7519, south: 43.7247, west: 7.4090, east: 7.4399 },
        center: { lat: 43.7384, lng: 7.4246 },
        zoom: 13
      },
      {
        name: 'Mongolia',
        code: 'MN',
        bounds: { north: 52.1496, south: 41.5974, west: 87.7512, east: 119.9243 },
        center: { lat: 46.8625, lng: 103.8467 },
        zoom: 5
      },
      {
        name: 'Montenegro',
        code: 'ME',
        bounds: { north: 43.5701, south: 41.8500, west: 18.4355, east: 20.3567 },
        center: { lat: 42.7087, lng: 19.3744 },
        zoom: 8
      },
      {
        name: 'Montserrat',
        code: 'MS',
        bounds: { north: 16.8240, south: 16.6719, west: -62.2420, east: -62.1461 },
        center: { lat: 16.7425, lng: -62.1874 },
        zoom: 12
      },
      {
        name: 'Morocco',
        code: 'MA',
        bounds: { north: 35.9224, south: 27.6661, west: -17.0204, east: -1.1246 },
        center: { lat: 31.6295, lng: -7.9811 },
        zoom: 6
      },
      {
        name: 'Mozambique',
        code: 'MZ',
        bounds: { north: -10.4719, south: -26.8687, west: 30.2138, east: 40.8426 },
        center: { lat: -18.6657, lng: 35.5296 },
        zoom: 6
      },
      {
        name: 'Myanmar',
        code: 'MM',
        bounds: { north: 28.5478, south: 9.7845, west: 92.1719, east: 101.1700 },
        center: { lat: 21.9162, lng: 95.9560 },
        zoom: 6
      },
      {
        name: 'Namibia',
        code: 'NA',
        bounds: { north: -16.9634, south: -28.9707, west: 11.7341, east: 25.2617 },
        center: { lat: -22.9576, lng: 18.4904 },
        zoom: 6
      },
      {
        name: 'Nauru',
        code: 'NR',
        bounds: { north: -0.5027, south: -0.5541, west: 166.9090, east: 166.9589 },
        center: { lat: -0.5228, lng: 166.9315 },
        zoom: 13
      },
      {
        name: 'Nepal',
        code: 'NP',
        bounds: { north: 30.4227, south: 26.3479, west: 80.0884, east: 88.2015 },
        center: { lat: 28.3949, lng: 84.1240 },
        zoom: 7
      },
      {
        name: 'Netherlands',
        code: 'NL',
        bounds: { north: 53.6756, south: 50.7503, west: 3.3316, east: 7.2275 },
        center: { lat: 52.1326, lng: 5.2913 },
        zoom: 7
      },
      {
        name: 'New Caledonia',
        code: 'NC',
        bounds: { north: -19.5493, south: -22.6980, west: 163.5647, east: 167.1200 },
        center: { lat: -20.9043, lng: 165.6180 },
        zoom: 8
      },
      {
        name: 'New Zealand',
        code: 'NZ',
        bounds: { north: -29.2420, south: -52.6194, west: 165.8142, east: 179.1094 },
        center: { lat: -40.9006, lng: 174.8860 },
        zoom: 5
      },
      {
        name: 'Nicaragua',
        code: 'NI',
        bounds: { north: 15.0258, south: 10.7268, west: -87.6684, east: -82.7382 },
        center: { lat: 12.8654, lng: -85.2072 },
        zoom: 7
      },
      {
        name: 'Niger',
        code: 'NE',
        bounds: { north: 23.5250, south: 11.6937, west: 0.1689, east: 16.0000 },
        center: { lat: 17.6078, lng: 8.0817 },
        zoom: 5
      },
      {
        name: 'Nigeria',
        code: 'NG',
        bounds: { north: 13.8659, south: 4.2406, west: 2.6917, east: 14.5771 },
        center: { lat: 9.0820, lng: 8.6753 },
        zoom: 6
      },
      {
        name: 'Niue',
        code: 'NU',
        bounds: { north: -18.9510, south: -19.1552, west: -169.9510, east: -169.7844 },
        center: { lat: -19.0544, lng: -169.8672 },
        zoom: 12
      },
      {
        name: 'Norfolk Island',
        code: 'NF',
        bounds: { north: -28.9955, south: -29.0625, west: 167.9120, east: 167.9990 },
        center: { lat: -29.0408, lng: 167.9547 },
        zoom: 12
      },
      {
        name: 'North Korea',
        code: 'KP',
        bounds: { north: 43.0089, south: 37.6735, west: 124.2656, east: 130.6820 },
        center: { lat: 40.3399, lng: 127.5101 },
        zoom: 6
      },
      {
        name: 'Northern Mariana Islands',
        code: 'MP',
        bounds: { north: 20.5534, south: 14.1102, west: 144.8863, east: 146.0648 },
        center: { lat: 17.3308, lng: 145.3846 },
        zoom: 9
      },
      {
        name: 'Norway',
        code: 'NO',
        bounds: { north: 80.6571, south: 57.9774, west: 4.6509, east: 31.2934 },
        center: { lat: 60.4720, lng: 8.4689 },
        zoom: 4
      },
      {
        name: 'Oman',
        code: 'OM',
        bounds: { north: 26.3959, south: 16.6510, west: 51.9999, east: 59.8362 },
        center: { lat: 21.4735, lng: 55.9754 },
        zoom: 6
      },
      {
        name: 'Pakistan',
        code: 'PK',
        bounds: { north: 37.0841, south: 23.6345, west: 60.8742, east: 77.8374 },
        center: { lat: 30.3753, lng: 69.3451 },
        zoom: 5
      },
      {
        name: 'Palau',
        code: 'PW',
        bounds: { north: 8.2223, south: 2.8036, west: 131.1179, east: 134.7241 },
        center: { lat: 7.5150, lng: 134.5825 },
        zoom: 9
      },
      {
        name: 'Palestine',
        code: 'PS',
        bounds: { north: 32.5521, south: 31.2201, west: 34.2180, east: 35.5739 },
        center: { lat: 31.9522, lng: 35.2332 },
        zoom: 9
      },
      {
        name: 'Panama',
        code: 'PA',
        bounds: { north: 9.6376, south: 7.2019, west: -83.0514, east: -77.1567 },
        center: { lat: 8.5380, lng: -80.7821 },
        zoom: 7
      },
      {
        name: 'Papua New Guinea',
        code: 'PG',
        bounds: { north: -0.3044, south: -12.4619, west: 140.8427, east: 159.9609 },
        center: { lat: -6.3150, lng: 143.9555 },
        zoom: 6
      },
      {
        name: 'Paraguay',
        code: 'PY',
        bounds: { north: -19.2940, south: -27.6084, west: -62.6470, east: -54.2593 },
        center: { lat: -23.4425, lng: -58.4438 },
        zoom: 6
      },
      {
        name: 'Peru',
        code: 'PE',
        bounds: { north: -0.0389, south: -18.3520, west: -84.6359, east: -68.6530 },
        center: { lat: -9.1900, lng: -75.0152 },
        zoom: 5
      },
      {
        name: 'Philippines',
        code: 'PH',
        bounds: { north: 21.1206, south: 4.6432, west: 116.9315, east: 126.6015 },
        center: { lat: 12.8797, lng: 121.7740 },
        zoom: 6
      },
      {
        name: 'Pitcairn Islands',
        code: 'PN',
        bounds: { north: -24.3158, south: -25.0842, west: -130.7491, east: -124.7722 },
        center: { lat: -24.7036, lng: -127.4393 },
        zoom: 12
      },
      {
        name: 'Poland',
        code: 'PL',
        bounds: { north: 54.9253, south: 48.9122, west: 13.9773, east: 24.2913 },
        center: { lat: 51.9194, lng: 19.1451 },
        zoom: 6
      },
      {
        name: 'Portugal',
        code: 'PT',
        bounds: { north: 42.1543, south: 36.9612, west: -9.5261, east: -6.1891 },
        center: { lat: 39.3999, lng: -8.2245 },
        zoom: 7
      },
      {
        name: 'Puerto Rico',
        code: 'PR',
        bounds: { north: 18.5206, south: 17.8814, west: -67.2714, east: -65.2421 },
        center: { lat: 18.2208, lng: -66.5901 },
        zoom: 9
      },
      {
        name: 'Qatar',
        code: 'QA',
        bounds: { north: 26.1542, south: 24.4706, west: 50.7439, east: 51.6067 },
        center: { lat: 25.3548, lng: 51.1839 },
        zoom: 9
      },
      {
        name: 'Reunion',
        code: 'RE',
        bounds: { north: -20.8717, south: -21.3897, west: 55.2115, east: 55.8366 },
        center: { lat: -21.1151, lng: 55.5364 },
        zoom: 10
      },
      {
        name: 'Romania',
        code: 'RO',
        bounds: { north: 48.3106, south: 43.5986, west: 20.0910, east: 29.8446 },
        center: { lat: 45.9432, lng: 24.9668 },
        zoom: 6
      },
      {
        name: 'Russia',
        code: 'RU',
        bounds: { north: 81.8586, south: 41.1885, west: -180.0, east: 180.0 },
        center: { lat: 61.5240, lng: 105.3188 },
        zoom: 3
      },
      {
        name: 'Rwanda',
        code: 'RW',
        bounds: { north: -1.0539, south: -2.8408, west: 28.8617, east: 30.8993 },
        center: { lat: -1.9403, lng: 29.8739 },
        zoom: 8
      },
      {
        name: 'Saint Helena',
        code: 'SH',
        bounds: { north: -15.8650, south: -16.0196, west: -5.8095, east: -5.6450 },
        center: { lat: -24.1434, lng: -10.0307 },
        zoom: 11
      },
      {
        name: 'Saint Kitts and Nevis',
        code: 'KN',
        bounds: { north: 17.4200, south: 17.0960, west: -62.8696, east: -62.5434 },
        center: { lat: 17.3578, lng: -62.7829 },
        zoom: 11
      },
      {
        name: 'Saint Lucia',
        code: 'LC',
        bounds: { north: 14.1105, south: 13.7047, west: -61.0804, east: -60.8742 },
        center: { lat: 13.9094, lng: -60.9789 },
        zoom: 11
      },
      {
        name: 'Saint Pierre and Miquelon',
        code: 'PM',
        bounds: { north: 47.1430, south: 46.7600, west: -56.4200, east: -56.1250 },
        center: { lat: 46.9419, lng: -56.2711 },
        zoom: 11
      },
      {
        name: 'Saint Vincent and the Grenadines',
        code: 'VC',
        bounds: { north: 13.3778, south: 12.5833, west: -61.4583, east: -61.1139 },
        center: { lat: 12.9843, lng: -61.2872 },
        zoom: 11
      },
      {
        name: 'Samoa',
        code: 'WS',
        bounds: { north: -13.4200, south: -14.0400, west: -172.7986, east: -171.4152 },
        center: { lat: -13.7590, lng: -172.1046 },
        zoom: 10
      },
      {
        name: 'San Marino',
        code: 'SM',
        bounds: { north: 43.9922, south: 43.8937, west: 12.4034, east: 12.5160 },
        center: { lat: 43.9424, lng: 12.4578 },
        zoom: 12
      },
      {
        name: 'Sao Tome and Principe',
        code: 'ST',
        bounds: { north: 1.7013, south: 0.0249, west: 6.4701, east: 7.4663 },
        center: { lat: 0.1864, lng: 6.6131 },
        zoom: 10
      },
      {
        name: 'Saudi Arabia',
        code: 'SA',
        bounds: { north: 32.1543, south: 16.3470, west: 34.4956, east: 55.6666 },
        center: { lat: 23.8859, lng: 45.0792 },
        zoom: 5
      },
      {
        name: 'Senegal',
        code: 'SN',
        bounds: { north: 16.6919, south: 12.3072, west: -17.5352, east: -11.3458 },
        center: { lat: 14.4974, lng: -14.4524 },
        zoom: 6
      },
      {
        name: 'Serbia',
        code: 'RS',
        bounds: { north: 46.1717, south: 42.2452, west: 18.8170, east: 23.0063 },
        center: { lat: 44.0165, lng: 21.0059 },
        zoom: 7
      },
      {
        name: 'Seychelles',
        code: 'SC',
        bounds: { north: -3.7159, south: -10.4649, west: 45.9989, east: 56.2977 },
        center: { lat: -4.6796, lng: 55.4920 },
        zoom: 9
      },
      {
        name: 'Sierra Leone',
        code: 'SL',
        bounds: { north: 10.0469, south: 6.9298, west: -13.3076, east: -10.2849 },
        center: { lat: 8.4606, lng: -11.7799 },
        zoom: 7
      },
      {
        name: 'Singapore',
        code: 'SG',
        bounds: { north: 1.4706, south: 1.1645, west: 103.6057, east: 104.0305 },
        center: { lat: 1.3521, lng: 103.8198 },
        zoom: 11
      },
      {
        name: 'Slovakia',
        code: 'SK',
        bounds: { north: 49.7036, south: 47.6686, west: 16.7437, east: 22.6943 },
        center: { lat: 48.6690, lng: 19.6990 },
        zoom: 7
      },
      {
        name: 'Slovenia',
        code: 'SI',
        bounds: { north: 46.9665, south: 45.3316, west: 13.2458, east: 16.7402 },
        center: { lat: 46.1512, lng: 14.9955 },
        zoom: 8
      },
      {
        name: 'Solomon Islands',
        code: 'SB',
        bounds: { north: -5.3170, south: -11.8506, west: 155.5086, east: 166.9809 },
        center: { lat: -9.6457, lng: 160.1562 },
        zoom: 8
      },
      {
        name: 'Somalia',
        code: 'SO',
        bounds: { north: 11.9791, south: -1.6752, west: 40.9865, east: 51.4257 },
        center: { lat: 5.1521, lng: 46.1996 },
        zoom: 6
      },
      {
        name: 'South Africa',
        code: 'ZA',
        bounds: { north: -22.1255, south: -34.8191, west: 16.4699, east: 32.8931 },
        center: { lat: -30.5595, lng: 22.9375 },
        zoom: 5
      },
      {
        name: 'South Korea',
        code: 'KR',
        bounds: { north: 38.6122, south: 33.1909, west: 125.8873, east: 131.8727 },
        center: { lat: 35.9078, lng: 127.7669 },
        zoom: 7
      },
      {
        name: 'South Sudan',
        code: 'SS',
        bounds: { north: 12.2480, south: 3.4889, west: 23.8869, east: 35.2980 },
        center: { lat: 7.8626, lng: 29.6947 },
        zoom: 6
      },
      {
        name: 'Spain',
        code: 'ES',
        bounds: { north: 43.7913, south: 35.1738, west: -9.3014, east: 4.3278 },
        center: { lat: 40.4637, lng: -3.7492 },
        zoom: 6
      },
      {
        name: 'Sri Lanka',
        code: 'LK',
        bounds: { north: 9.9231, south: 5.8435, west: 79.5760, east: 82.8574 },
        center: { lat: 7.8731, lng: 80.7718 },
        zoom: 10
      },
      {
        name: 'Sudan',
        code: 'SD',
        bounds: { north: 22.2322, south: 8.6856, west: 21.8149, east: 38.6077 },
        center: { lat: 12.8628, lng: 30.2176 },
        zoom: 5
      },
      {
        name: 'Suriname',
        code: 'SR',
        bounds: { north: 6.0252, south: 1.8312, west: -58.0861, east: -53.9773 },
        center: { lat: 3.9193, lng: -56.0278 },
        zoom: 7
      },
      {
        name: 'Svalbard and Jan Mayen',
        code: 'SJ',
        bounds: { north: 80.7621, south: 70.9167, west: -9.0313, east: 33.2871 },
        center: { lat: 77.5536, lng: 23.6702 },
        zoom: 4
      },
      {
        name: 'Swaziland',
        code: 'SZ',
        bounds: { north: -25.7197, south: -27.3175, west: 30.7908, east: 32.1349 },
        center: { lat: -26.5225, lng: 31.4659 },
        zoom: 8
      },
      {
        name: 'Sweden',
        code: 'SE',
        bounds: { north: 69.0599, south: 55.3617, west: 11.0273, east: 24.1773 },
        center: { lat: 60.1282, lng: 18.6435 },
        zoom: 5
      },
      {
        name: 'Switzerland',
        code: 'CH',
        bounds: { north: 47.8982, south: 45.7281, west: 5.8246, east: 10.6234 },
        center: { lat: 46.8182, lng: 8.2275 },
        zoom: 8
      },
      {
        name: 'Syria',
        code: 'SY',
        bounds: { north: 37.3191, south: 32.3129, west: 35.7277, east: 42.3495 },
        center: { lat: 34.8021, lng: 38.9968 },
        zoom: 6
      },
      {
        name: 'Taiwan',
        code: 'TW',
        bounds: { north: 25.2954, south: 21.8966, west: 119.5343, east: 122.0069 },
        center: { lat: 23.6978, lng: 120.9605 },
        zoom: 7
      },
      {
        name: 'Tajikistan',
        code: 'TJ',
        bounds: { north: 41.0447, south: 36.6711, west: 67.4422, east: 75.1539 },
        center: { lat: 38.8610, lng: 71.2761 },
        zoom: 6
      },
      {
        name: 'Tanzania',
        code: 'TZ',
        bounds: { north: -0.9858, south: -11.7612, west: 29.3399, east: 40.3165 },
        center: { lat: -6.3690, lng: 34.8888 },
        zoom: 6
      },
      {
        name: 'Thailand',
        code: 'TH',
        bounds: { north: 20.4648, south: 5.6109, west: 97.3436, east: 105.6390 },
        center: { lat: 15.8700, lng: 100.9925 },
        zoom: 6
      },
      {
        name: 'Togo',
        code: 'TG',
        bounds: { north: 11.1387, south: 6.1044, west: -0.1473, east: 1.7802 },
        center: { lat: 8.6195, lng: 0.8248 },
        zoom: 7
      },
      {
        name: 'Tokelau',
        code: 'TK',
        bounds: { north: -8.5536, south: -9.3812, west: -172.5003, east: -171.2114 },
        center: { lat: -8.9674, lng: -171.8559 },
        zoom: 12
      },
      {
        name: 'Tonga',
        code: 'TO',
        bounds: { north: -15.5629, south: -21.4550, west: -175.6822, east: -173.9075 },
        center: { lat: -21.1789, lng: -175.1982 },
        zoom: 9
      },
      {
        name: 'Trinidad and Tobago',
        code: 'TT',
        bounds: { north: 11.3463, south: 10.0400, west: -61.9237, east: -60.5179 },
        center: { lat: 10.6918, lng: -61.2225 },
        zoom: 9
      },
      {
        name: 'Tunisia',
        code: 'TN',
        bounds: { north: 37.3499, south: 30.2405, west: 7.5248, east: 11.5883 },
        center: { lat: 33.8869, lng: 9.5375 },
        zoom: 7
      },
      {
        name: 'Turkey',
        code: 'TR',
        bounds: { north: 42.1076, south: 35.8156, west: 25.6613, east: 44.8349 },
        center: { lat: 38.9637, lng: 35.2433 },
        zoom: 6
      },
      {
        name: 'Turkmenistan',
        code: 'TM',
        bounds: { north: 42.7975, south: 35.1413, west: 52.5024, east: 66.6843 },
        center: { lat: 38.9697, lng: 59.5563 },
        zoom: 6
      },
      {
        name: 'Turks and Caicos Islands',
        code: 'TC',
        bounds: { north: 21.9619, south: 21.4220, west: -72.4838, east: -71.1236 },
        center: { lat: 21.6940, lng: -71.7979 },
        zoom: 10
      },
      {
        name: 'Tuvalu',
        code: 'TV',
        bounds: { north: -5.6419, south: -10.8019, west: 176.0648, east: 179.8632 },
        center: { lat: -7.1095, lng: 177.6493 },
        zoom: 10
      },
      {
        name: 'Uganda',
        code: 'UG',
        bounds: { north: 4.2144, south: -1.4823, west: 29.5732, east: 35.0003 },
        center: { lat: 1.3733, lng: 32.2903 },
        zoom: 7
      },
      {
        name: 'Ukraine',
        code: 'UA',
        bounds: { north: 52.3791, south: 45.0395, west: 22.1370, east: 40.2275 },
        center: { lat: 48.3794, lng: 31.1656 },
        zoom: 6
      },
      {
        name: 'United Arab Emirates',
        code: 'AE',
        bounds: { north: 26.0841, south: 22.6333, west: 51.5795, east: 56.3968 },
        center: { lat: 23.4241, lng: 53.8478 },
        zoom: 7
      },
      {
        name: 'United Kingdom',
        code: 'GB',
        bounds: { north: 60.9502, south: 49.0725, west: -8.8081, east: 1.9214 },
        center: { lat: 55.3781, lng: -3.4360 },
        zoom: 6
      },
      {
        name: 'United States',
        code: 'US',
        bounds: { north: 71.5388, south: 18.7763, west: -178.1165, east: -66.9346 },
        center: { lat: 39.8283, lng: -98.5795 },
        zoom: 4
      },
      {
        name: 'Uruguay',
        code: 'UY',
        bounds: { north: -30.1092, south: -35.7828, west: -58.4277, east: -53.1094 },
        center: { lat: -32.5228, lng: -55.7658 },
        zoom: 7
      },
      {
        name: 'US Virgin Islands',
        code: 'VI',
        bounds: { north: 18.4158, south: 17.6739, west: -65.1013, east: -64.5652 },
        center: { lat: 18.3358, lng: -64.8963 },
        zoom: 10
      },
      {
        name: 'Uzbekistan',
        code: 'UZ',
        bounds: { north: 45.5868, south: 37.1449, west: 56.0000, east: 73.1397 },
        center: { lat: 41.3775, lng: 64.5853 },
        zoom: 6
      },
      {
        name: 'Vanuatu',
        code: 'VU',
        bounds: { north: -13.0739, south: -20.2489, west: 166.5249, east: 170.2364 },
        center: { lat: -15.3767, lng: 166.9592 },
        zoom: 8
      },
      {
        name: 'Vatican City',
        code: 'VA',
        bounds: { north: 41.9074, south: 41.9002, west: 12.4457, east: 12.4584 },
        center: { lat: 41.9029, lng: 12.4534 },
        zoom: 15
      },
      {
        name: 'Venezuela',
        code: 'VE',
        bounds: { north: 15.9158, south: 0.6475, west: -73.3800, east: -59.8038 },
        center: { lat: 6.4238, lng: -66.5897 },
        zoom: 5
      },
      {
        name: 'Vietnam',
        code: 'VN',
        bounds: { north: 23.3927, south: 8.5597, west: 102.1440, east: 109.4641 },
        center: { lat: 14.0583, lng: 108.2772 },
        zoom: 6
      },
      {
        name: 'Wallis and Futuna',
        code: 'WF',
        bounds: { north: -13.2167, south: -14.3144, west: -178.1848, east: -176.1617 },
        center: { lat: -13.7687, lng: -177.1561 },
        zoom: 10
      },
      {
        name: 'Western Sahara',
        code: 'EH',
        bounds: { north: 27.6696, south: 20.7741, west: -17.1031, east: -8.6702 },
        center: { lat: 24.2155, lng: -12.8858 },
        zoom: 6
      },
      {
        name: 'Yemen',
        code: 'YE',
        bounds: { north: 19.0, south: 12.1110, west: 42.2845, east: 53.1085 },
        center: { lat: 15.5527, lng: 48.5164 },
        zoom: 6
      },
      {
        name: 'Zambia',
        code: 'ZM',
        bounds: { north: -8.2712, south: -18.0794, west: 21.9984, east: 33.5057 },
        center: { lat: -13.1339, lng: 27.8493 },
        zoom: 6
      },
      {
        name: 'Zimbabwe',
        code: 'ZW',
        bounds: { north: -15.6097, south: -22.4241, west: 25.2373, east: 33.0563 },
        center: { lat: -19.0154, lng: 29.1549 },
        zoom: 6
      }
    ];
  }
  